import setCustomerAddressOnCartBilling from './setCustomerAddressOnBilling';

export default setCustomerAddressOnCartBilling;
